export { getWishlistServerAction } from 'next-flight-server-reference-proxy-loader?id=00c37582022cb0e44b95eb363ab7b5ba1bc29f8c7e&name=getWishlistServerAction!'